import { StargraveShipUpgrade } from '../../types';

export const stargraveShipUpgrades: StargraveShipUpgrade[] = [
  {
    id: 'advanced-medical-suite',
    name: 'Advanced Medical Suite',
    cost: 500,
    summary: 'After each game, reroll one soldier Survival Roll; the second result must be used. Requires a medic in the crew.',
    maximum: 1,
    sourcePage: 99,
  },
  {
    id: 'armament-workshop',
    name: 'Armament Workshop',
    cost: 500,
    summary: 'After a successful pre-game Armoury power, improve two eligible weapons, waive upkeep for two combat-armour suits, or take one of each option.',
    maximum: 1,
    sourcePage: 99,
  },
  {
    id: 'communications-array',
    name: 'Communications Array',
    cost: 300,
    summary: 'Gives one crew member +2 to Activation Rolls for Bribe.',
    maximum: 1,
    sourcePage: 99,
  },
  {
    id: 'external-cargo-pods',
    name: 'External Cargo Pods',
    cost: 300,
    summary: 'Adds 20% to the listed value whenever the crew sells trade goods.',
    maximum: 1,
    sourcePage: 99,
  },
  {
    id: 'extra-quarters',
    name: 'Extra Quarters',
    cost: 1000,
    summary: 'Core rule: raises the specialist allowance by one. This app does not enforce soldier or specialist limits.',
    maximum: 1,
    sourcePage: 99,
  },
  {
    id: 'meditation-chamber',
    name: 'Meditation Chamber',
    cost: 400,
    summary: 'Gives one crew member +2 to Activation Rolls for Mystic Trance.',
    maximum: 2,
    sourcePage: 99,
  },
  {
    id: 'robotics-workshop',
    name: 'Robotics Workshop',
    cost: 650,
    summary: 'Between games, gives one crew member +1 to one Out of Game activation for Create Robot, Remote Guidance, or Re-wire Robot.',
    maximum: 1,
    sourcePage: 99,
  },
  {
    id: 'weapon-locker',
    name: 'Weapon Locker',
    cost: 600,
    summary: 'Before each game, one soldier may use a +1 Damage pistol, carbine, or shotgun that occupies their gear slot for that game.',
    maximum: 1,
    sourcePage: 99,
  },
];
